import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ProgressComponent } from './progress.component';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressModel {
  private readonly progressShow = new Subject<boolean>();
  private readonly delayProgressTime = 500;

  private intervalId: ReturnType<typeof setTimeout> | undefined;

  constructor(dialog: MatDialog) {
    this.progressShow.pipe(takeUntilDestroyed()).subscribe(res => {
      const current = dialog.getDialogById(ProgressComponent.progressId);
      if (res) {
        if (!current) {
          ProgressComponent.open(dialog);
        }
      } else {
        current?.close();
      }
    });
  }

  show(): void {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
    this.intervalId = setTimeout(() => this.progressShow.next(true), this.delayProgressTime);
  }

  hide(): void {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
    this.progressShow.next(false);
  }
}
